import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from './permission.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {

    constructor(
        private router: Router,
        private permissionService: PermissionService
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const path = route.routeConfig?.path;
        const roles = localStorage.getItem('roles') || '';

        // Streamlit — all roles allowed
        if (path === 'streamlit') {
            if (roles.length > 0) {
                return true;
            }
            this.router.navigate(['/forbidden']);
            return false;
        }

        // active-users and storage-monitor — only via permissions
        if (this.permissionService.can('ACTIVE_USERS_VIEW') ||
            this.permissionService.can('STORAGE_MONITOR_VIEW')) {
            return true;
        }

        this.router.navigate(['/forbidden']);
        return false;
    }
}